import React, {Fragment, useState} from 'react'
import {currentLang} from './../../../utils/functions';
import {siteInfo} from './../../../utils/config';
import {truncate} from 'lodash';

function SchemaProduct({data}) {
    return (
        <div itemtype="http://schema.org/Product" itemscope>
            <meta itemprop="name" content={data.title+" | "+siteInfo[currentLang()]['title']}/>
            <link itemprop="image" href={data.image_url} /> 
            <meta itemprop="description" content={truncate(data.body, {'length':150})}/> 
            
            <div itemprop="offers" itemtype="http://schema.org/Offer" itemscope> 
                <link itemprop="url" href={window.location.href} /> 
                {data.shop_stock_status == 'instock' && <meta itemprop="availability" content="https://schema.org/InStock"/> }
                <meta itemprop="priceCurrency" content={siteInfo[currentLang()]['currency']} /> 
                <meta itemprop="price" content={data.shop_package_price} /> 
            </div>
            <div itemprop="seller" itemtype="http://schema.org/Organization" itemscope> 
                <meta itemprop="name" content="vleespakketten" />
            </div>
            {/*
            <div itemprop="aggregateRating" itemtype="http://schema.org/AggregateRating" itemscope> 
                <meta itemprop="reviewCount" content="3500" /> 
                <meta itemprop="ratingValue" content="4.8" /> 
            </div>
            */}
            <div itemprop="brand" itemtype="http://schema.org/Thing" itemscope> 
                <meta itemprop="name" content={siteInfo[currentLang()]['domain']}/> 
            </div> 
        </div>
    )
}

export default SchemaProduct
